var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49492 2.19526C7.77387 1.93491 8.22613 1.93491 8.50508 2.19526L12.0765 5.5286C12.3555 5.78894 12.3555 6.21106 12.0765 6.4714C11.7976 6.73175 11.3453 6.73175 11.0664 6.4714L8.71429 4.27614V11.3333C8.71429 11.7015 8.39449 12 8 12C7.60551 12 7.28571 11.7015 7.28571 11.3333V4.27614L4.93365 6.4714C4.6547 6.73175 4.20244 6.73175 3.9235 6.4714C3.64455 6.21106 3.64455 5.78894 3.9235 5.5286L7.49492 2.19526ZM3 13.3333C3 12.9651 3.3198 12.6667 3.71429 12.6667H12.2857C12.6802 12.6667 13 12.9651 13 13.3333C13 13.7015 12.6802 14 12.2857 14H3.71429C3.3198 14 3 13.7015 3 13.3333Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.23a1ae9a7c996388cac54780f48fa554.svg";
export { ForwardRef as ReactComponent };